export default __webpack_public_path__ + "static/media/vertical-dots.8b28c489.svg";